class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (details && details.classList.contains('cosmoshop-search-closing')) return;
    details && details.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  isHeaderSearch() {
    return this.classList.contains('header__search') || this.classList.contains('cosmoshop-header__search');
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);

    const details = event.target.closest('details') || this.detailsContainer;
    if (this.cosmoshopSearchCloseTimer) {
      clearTimeout(this.cosmoshopSearchCloseTimer);
      this.cosmoshopSearchCloseTimer = null;
    }

    details.classList.remove('cosmoshop-search-closing');
    details.setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');

    if (this.isHeaderSearch()) {
      document.body.classList.add('cosmoshop-search-open');
      document.documentElement.classList.add('cosmoshop-search-open');

      // Make the open state visible synchronously. Some mobile browsers can focus
      // the search input before a deferred opening class is painted, leaving the
      // functional input off-screen/invisible until another layout pass occurs.
      details.classList.add('cosmoshop-search-opening');
    }

    this.forceHeaderVisible();
    document.body.addEventListener('click', this.onBodyClickEvent);
    this.lockPageScroll();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    if (this.isHeaderSearch() && this.detailsContainer.hasAttribute('open')) {
      if (this.detailsContainer.classList.contains('cosmoshop-search-closing')) return;

      this.detailsContainer.classList.add('cosmoshop-search-closing');
      this.detailsContainer.classList.remove('cosmoshop-search-opening');
      this.summaryToggle.setAttribute('aria-expanded', 'false');
      document.body.removeEventListener('click', this.onBodyClickEvent);

      this.cosmoshopSearchCloseTimer = window.setTimeout(() => {
        this.detailsContainer.removeAttribute('open');
        this.detailsContainer.classList.remove('cosmoshop-search-closing');
        document.body.classList.remove('cosmoshop-search-open');
        document.documentElement.classList.remove('cosmoshop-search-open');
        this.unlockPageScroll();
        this.cosmoshopSearchCloseTimer = null;
      }, 300);
      return;
    }

    this.detailsContainer.removeAttribute('open');
    this.detailsContainer.classList.remove('cosmoshop-search-opening', 'cosmoshop-search-closing');
    if (this.isHeaderSearch()) {
      document.body.classList.remove('cosmoshop-search-open');
      document.documentElement.classList.remove('cosmoshop-search-open');
    }
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    this.unlockPageScroll();
  }

  forceHeaderVisible() {
    if (!this.classList.contains('header__search')) return;

    const header = document.getElementById('shopify-section-header');
    if (!header) return;

    header.classList.add('shopify-section-header-sticky', 'animate');
    header.classList.remove('shopify-section-header-hidden');
  }

  lockPageScroll() {
    if (!this.classList.contains('header__search')) return;
    if (document.body.classList.contains('cosmoshop-search-scroll-locked')) return;

    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    document.documentElement.classList.add('cosmoshop-search-scroll-locked');
    document.body.classList.add('cosmoshop-search-scroll-locked');
    document.body.dataset.cosmoshopSearchScrollY = scrollY.toString();

    this.preventSearchPageScrollEvent = this.preventSearchPageScrollEvent || this.preventSearchPageScroll.bind(this);
    document.addEventListener('wheel', this.preventSearchPageScrollEvent, { passive: false });
    document.addEventListener('touchmove', this.preventSearchPageScrollEvent, { passive: false });
  }

  preventSearchPageScroll(event) {
    if (!document.body.classList.contains('cosmoshop-search-scroll-locked')) return;

    const scrollableSearchResults = event.target.closest('.predictive-search');
    if (scrollableSearchResults && scrollableSearchResults.scrollHeight > scrollableSearchResults.clientHeight) return;

    event.preventDefault();
  }

  unlockPageScroll() {
    if (!this.classList.contains('header__search')) return;
    if (!document.body.classList.contains('cosmoshop-search-scroll-locked')) return;

    const scrollY = parseInt(document.body.dataset.cosmoshopSearchScrollY || '0', 10);

    document.documentElement.classList.remove('cosmoshop-search-scroll-locked');
    document.body.classList.remove('cosmoshop-search-scroll-locked');
    delete document.body.dataset.cosmoshopSearchScrollY;

    document.removeEventListener('wheel', this.preventSearchPageScrollEvent);
    document.removeEventListener('touchmove', this.preventSearchPageScrollEvent);

    if (!Number.isNaN(scrollY)) window.scrollTo(0, scrollY);
  }
}

customElements.define('details-modal', DetailsModal);
